<template>
  <div class="mp-filter">
    <div class="mp-filter__row">
      <div class="mp-filter__label">
        <span class="mp-filter__fi" style="background: #ffa940">
          <MarketUviewIcon :name="MARKET_FILTER_UVIEW_ICONS.festival" :size="12" color="#fff" />
        </span>
        节日
      </div>
      <div class="mp-filter__tags">
        <span
          v-for="tag in festivalTags"
          :key="'f-' + tag.key"
          class="mp-filter__tag"
          :class="{ 'is-active': tag.active }"
          @click="onFestival(tag)"
        >
          {{ tag.label }}
        </span>
      </div>
    </div>
    <div v-if="showIndustry" class="mp-filter__row">
      <div class="mp-filter__label">
        <span class="mp-filter__fi" style="background: #67c23a">
          <MarketUviewIcon :name="MARKET_FILTER_UVIEW_ICONS.industry" :size="12" color="#fff" />
        </span>
        行业
      </div>
      <div class="mp-filter__tags">
        <span
          v-for="tag in industryTags"
          :key="'i-' + tag.key"
          class="mp-filter__tag"
          :class="{ 'is-active': tag.active }"
          @click="onIndustry(tag.key)"
        >
          {{ tag.label }}
        </span>
      </div>
    </div>
    <div class="mp-filter__row">
      <div class="mp-filter__label">
        <span class="mp-filter__fi" style="background: #8b6df0">
          <MarketUviewIcon :name="MARKET_FILTER_UVIEW_ICONS.scene" :size="12" color="#fff" />
        </span>
        场景
      </div>
      <div class="mp-filter__tags">
        <span
          v-for="tag in sceneTags"
          :key="'s-' + tag.key"
          class="mp-filter__tag"
          :class="{ 'is-active': tag.active }"
          @click="onScene(tag.key)"
        >
          {{ tag.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useMarketPortal } from '../useMarketPortal'
import { useMarketPortalStore } from '../useMarketPortalStore'
import { MARKET_FILTER_UVIEW_ICONS } from '../uview-icons'
import MarketUviewIcon from './MarketUviewIcon.vue'

defineOptions({ name: 'MarketFilterBar' })

withDefaults(
  defineProps<{
    showIndustry?: boolean
  }>(),
  { showIndustry: true }
)

const emit = defineEmits<{
  sceneChange: [sceneKey: number | undefined]
}>()

const { goto } = useMarketPortal()
const { festivalTabs, tradeRows, scenes } = useMarketPortalStore()
const activeScene = ref<number | 'all'>('all')
const activeIndustry = ref<string>('all')

const festivalTags = computed(() => [
  { key: 'all', label: '全部', active: true },
  ...festivalTabs.value.map((f) => ({
    key: String(f.key ?? f.name),
    label: f.name || '',
    active: false
  }))
])

const industryTags = computed(() => [
  { key: 'all', label: '全部', active: activeIndustry.value === 'all' },
  ...tradeRows.value.map((t) => ({
    key: String(t.key ?? t.name),
    label: t.name || '',
    active: activeIndustry.value === String(t.key ?? t.name)
  }))
])

const sceneTags = computed(() => [
  { key: 'all', label: '全部', active: activeScene.value === 'all' },
  ...scenes.value
    .filter((s) => !s.hideInActivity)
    .map((s) => ({
      key: String(s.key),
      label: s.name || '',
      active: activeScene.value === s.key
    }))
])

const onFestival = (tag: { key: string; label: string }) => {
  if (tag.key === 'all') return
  goto('cat', -1)
}

const onIndustry = (key: string) => {
  activeIndustry.value = key
}

const onScene = (key: string) => {
  if (key === 'all') {
    activeScene.value = 'all'
    emit('sceneChange', undefined)
    return
  }
  activeScene.value = Number(key)
  emit('sceneChange', Number(key))
}
</script>

<style lang="scss" scoped>
.mp-filter {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  &__label {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
    width: 74px;
    font-weight: 600;
    font-size: 14px;
  }

  &__fi {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  &__tag {
    padding: 3px 12px;
    border-radius: 14px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    background: #f5f6fa;
    transition: all 0.15s;
    border: 1px solid transparent;

    &:hover {
      color: #2b6de8;
    }

    &.is-active {
      background: #eef4ff;
      color: #2b6de8;
      border-color: #2b6de8;
      font-weight: 600;
    }
  }
}
</style>
